import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { UniqueMethod } from '../components/UniqueMethod';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsItFor } from '../components/WhoIsItFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQ } from '../components/FAQ';
import { OfferBlock } from '../components/OfferBlock';
import { Footer } from '../components/Footer';
import { SalesNotification } from '../components/SalesNotification';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-cream overflow-hidden" data-id="element-188">
      <Hero data-id="element-189" />
      <ProblemSection data-id="element-190" />
      <FailedSolutions data-id="element-191" />
      <UniqueMethod data-id="element-192" />
      <WhatYouGet data-id="element-193" />
      <WhoIsItFor data-id="element-194" />
      <HowItWorks data-id="element-195" />
      <ProofSection data-id="element-196" />
      <FAQ data-id="element-197" />
      <OfferBlock data-id="element-198" />
      <Footer data-id="element-199" />
      <SalesNotification data-id="element-200" />
    </main>;
}